module.exports = __webpack_public_path__ + "assets/img/zip.fc6a9534.svg";